import { pgTable, text, unique } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from './org-id';
import { TagType } from '../enums';
export const Tag = pgTable('tag', {
    ...orgTableBase,
    name: text('name').notNull(),
    color: text('color').notNull(),
    type: TagType('type').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq1: unique().on(table.orgId, table.name, table.type),
}));
//# sourceMappingURL=tag.js.map